// SideNavSingleLevel.tsx
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { NestedMenuItemLevels } from './nested-items.enum';
import { NestedMenuItem } from './useNestedMenu';

export type SideNavSingleLevelProps = {
  item: NestedMenuItem;
};

const SideNavSingleLevel: React.FC<SideNavSingleLevelProps> = ({ item }) => {
  const { pathname } = useLocation();

  const active = item?.to?.includes(pathname) ?? false;

  return (
    <>
      {
        item?.level &&
        item.level !== NestedMenuItemLevels.firstLevelWithChildren &&
        item.level !== NestedMenuItemLevels.nestedLevelWithChildren ? (
        <ListItemButton
          sx={{
            paddingLeft: `${item?.level && item.level > 2 ? item.level * 12 : 0}px`,
            color: 'neutral.400',
          }}
          className={`sidenav__item-button ${active ? 'sidenav__item-button--active' : ''
            }`}
        >
          <ListItemIcon sx={{margin:"0px -12px"}}>{item.icon}</ListItemIcon>
          <ListItemText primary={item.title} />
        </ListItemButton>
      ) : null}
    </>
  );
};

export default SideNavSingleLevel;
